module.exports = __webpack_public_path__ + "static/media/object-dark-grey-icon.8a7f039a.svg";